const Messages: Record<string, string> = {
  INVALID_EMAIL: 'Email is invalid',
  REQUIRED: 'Required field',
};

export default Messages;
